var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "RMApprove"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_vm._m(0), _vm._v(" "), _c('div', {}, [_c('b-card', [_c('div', {
    staticClass: "card-body",
    staticStyle: {
      "border": "1px solid #8080804d"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitCategory.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "PopupraiseRMDebitNoteEditTable",
    staticStyle: {
      "overflow-y": "scroll"
    },
    attrs: {
      "cellpadding": "5px",
      "cellspacing": "5px"
    }
  }), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Employee categories list")])])]), _vm._v(" "), _c('tbody', [(_vm.empCategories.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "align": "center"
    }
  }, [_vm._v("No Data Available.! ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.empCategories), function(item, index) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "font-size": "15px"
      }
    }, [_c('input', {
      staticClass: "categories",
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          return _vm.pushToFiltered($event, item, index)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "15px"
      }
    }, [_c('span', {
      staticClass: "ml-2"
    }, [_vm._v(_vm._s(item.EmpTypeName))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "PopupraiseRMDebitNoteEditTable",
    attrs: {
      "cellpadding": "5px",
      "cellspacing": "5px"
    }
  }), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Active Categories")])])]), _vm._v(" "), _c('tbody', [(_vm.FilterdData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "align": "center"
    }
  }, [_vm._v("No Data Available.! ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.FilterdData), function(item, index) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "font-size": "15px"
      }
    }, [_c('input', {
      staticClass: "ActiveCat",
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      on: {
        "click": function($event) {
          return _vm.removeFromFiltered($event, item, index)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "15px"
      }
    }, [_c('span', {
      staticClass: "ml-2",
      style: ([item.isNew ? {
        'color': 'orange'
      } : {
        'color': 'green'
      }])
    }, [_vm._v(_vm._s(item.EmpTypeName))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-4",
    staticStyle: {
      "text-align": "end"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Save")])])])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.Loading
    },
    on: {
      "update:active": function($event) {
        _vm.Loading = $event
      }
    }
  })], 1)], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('legend', [_vm._v("Emp Categories")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ea6d2d4","hasScoped":true}!./src/views/components/EmpCategories/EmpCategories.component.html
// module id = 1562
// module chunks = 1